import $ from "jquery";

(() => {
  if (!$(".kioskSelectbox__toggle").length) {
    return false;
  }

  $(".kioskSelectbox__toggle").each(function () {
    const $this = $(this);
    const parent = $this.parents(".kioskSelectbox");

    $this.on("click", function () {
      if (parent.hasClass("is-selectbox-open")) {
        parent.removeClass("is-selectbox-open");
      } else {
        parent.addClass("is-selectbox-open");
      }
    });
  });

  $(".kioskSelectbox__dropdown-item").each(function () {
    const $this = $(this);
    // const parent = $this.parents(".kioskSelectbox");
    updateLabel($this);

    $this.on("click", function () {
      $this.addClass("is-selected");
      $this.siblings().removeClass("is-selected");
      updateLabel($this);
    });
  });

  function updateLabel(el) {
    const parent = $(el).parents(".kioskSelectbox");
    const placeholder = parent.find(".kioskSelectbox__placeholder");
    const selectBox = parent.find(".kioskSelectbox__select");
    const val = $(el).text();

    if ($(el).hasClass("is-selected")) {
      placeholder.text(val);
      selectBox.val(val).trigger("change");
    }
  }
})();
